<template>
  <v-data-table class="elevation-1" :headers="headers" :items="items" :loading="loading" :items-per-page="100"
                :options.sync="params.options" :server-items-length="params.total"
                no-data-text="请至少输入重量或体积, 然后点击查询" :footer-props="{showFirstLastPage: true, showCurrentPage: true}">
    <template v-slot:top>
      <provider-filter :filters="params.filters">
        <v-text-field class="float-left mr-5" hide-details label="重量" v-model="params.filters.weight" suffix="KG"/>
        <v-text-field class="float-left" hide-details label="体积" v-model="params.filters.volume" suffix="CBM"/>
      </provider-filter>
      <!--        <v-btn icon @click="getData">
                <v-icon>mdi-magnify</v-icon>
              </v-btn>-->
      <v-divider/>
    </template>
    <template v-slot:item.order="{ item, index }">
      {{ index + 1 }}
    </template>
    <template v-slot:item.level="{ item }">
      {{ item.channel.provider.level }}
    </template>
    <template v-slot:item.channel.traffic_type="{ item }">
      {{ item.channel.trafficType }}
    </template>
    <template v-slot:item.channel_name="{ item }">
      {{ item.channel.channelName }}
    </template>
    <template v-slot:item.channel_type="{ item }">
      {{ item.channel.channelType }}
    </template>
    <template v-slot:item.min_time="{ item }">
      <span v-if="item.channel.minTime && item.channel.maxTime">{{ item.channel.minTime ? item.channel.minTime + " - " : "" }}{{ item.channel.maxTime }}天</span>
    </template>
    <template v-slot:item.price="{ item }">
      {{ `${item.price}元/${item.calcType === 1 ? "KG" : "CBM"}` }}
    </template>
    <template v-slot:item.total="{ item }">
      {{ item.total.toFixed(2)  }}元
    </template>
    <template v-slot:item.quoteDate="{ item }">
      {{ item.quoteDate }}
    </template>
    <template v-slot:item.channel.fees="{ item }">
      <div v-if="item.channel.fees">
        <p v-for="(fee, index) in item.channel.fees" :key="`${item.id}-${fee.name}-${index}`">
          {{ fee.name }}: {{ fee.price }}{{ fee.type === 1 ? "元" : "元/" + (item.calcType === 1 ? "KG" : "CBM") }}
        </p>
      </div>
    </template>
    <template v-slot:item.channel.remark="{ item }">
      <div v-if="item.channel.remark">
        <p v-for="(line, index) in item.channel.remark.split('\n')" :key="`${item.id}-${line}-${index}`">
          {{ line }}
        </p>
      </div>
    </template>
  </v-data-table>
</template>

<script>
import ProviderFilter from "@/page/Provider/ProviderFilter";

export default {
  name: "QuotationSearcher",
  components: {ProviderFilter},
  data() {
    return {
      loading: false,
      headers: [
        {text: "排名", align: "center", sortable: false, value: "order"},
        {text: "供应商代号", align: "center", sortable: false, value: "channel.provider.code"},
        {text: "等级", align: "center", sortable: true, value: "level"},
        {text: "国家", align: "center", sortable: false, value: "channel.country"},
        {text: "运输方式", align: "center", sortable: true, value: "channel.traffic_type"},
        {text: "渠道", align: "center", sortable: true, value: "channel_name"},
        {text: "渠道类别", align: "center", sortable: true, value: "channel_type"},
        {text: "仓库", align: "center", sortable: false, value: "repository"},
        {text: "时效", align: "center", sortable: true, value: "min_time"},
        {text: "报价", align: "center", sortable: false, value: "price"},
        {text: "最终金额", align: "center", sortable: true, value: "total"},
        {text: "报价日期", align: "center", sortable: true, value: "quoteDate"},
        {text: "收费项目", align: "left", sortable: false, value: "channel.fees", width: 200},
        {text: "备注", align: "left", sortable: false, value: "channel.remark", width: 300},
      ],
      items: [],
      params: {
        options: {
          sortBy: ["total"],
          sortDesc: [false]
        },
        filters: {
          quoteDate: null,
          search: null,
          trafficTypes: [],
          countries: [],
          channels: [],
          channelTypes: [],
          repositories: [],
          levels: [],
          weight: null,
          volume: null
        },
        total: null,
      },
    }
  },
  methods: {
    getData() {
      if (this.params.filters.weight || this.params.filters.volume) {
        this.loading = true
        this.items = []
        this.$axios.post('/quotation/best', this.params).then(
            res => {
              this.items = res.data.list
              this.params.total = res.data.total
              this.loading = false
              console.log(this.items)
            }
        )
      }
    },
  },
  watch: {
    'params.options': {
      deep: true,
      handler() {
        this.getData()
      }
    },
    'params.filters': {
      deep: true,
      handler() {
        this.params.options.page = 1
        this.getData()
      }
    }
  }
}
</script>

<style scoped>

</style>